import { Component } from '@angular/core';
import { PermissionsService } from 'src/app/services/permissions.service';
import { GhiseulUnicSettingsSidebar } from 'src/app/utils/enum/sidebar-settings';
import { environment } from 'src/environments/environment';

@Component({
    selector: 'app-ghiseul-unic-settings',
    templateUrl: './ghiseul-unic-settings.component.html',
    styleUrls: ['./ghiseul-unic-settings.component.scss']
})
export class GhiseulUnicSettingsComponent {
    readonly GhiseulUnicSettingsSidebar = GhiseulUnicSettingsSidebar;
    selectedComponent!: GhiseulUnicSettingsSidebar;
    env = environment;
    filteredComponents: string[] = [];

    constructor(private permissionsService: PermissionsService) {
        this.filterComponents();
    }

    filterComponents() {
        this.filteredComponents = [...this.componentKeys];

        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.ghiseu-status.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.STATUS)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.ghiseu-priorities.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.PRIORITY)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.tip-program-active.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.TIPURI_PROGRAM_ACTIVE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.ghiseu-module.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.MODULE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.locatii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.LOCATII)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.servicii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.SERVICII)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.module-locatii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.MODULE_LOCATII_ACTIVE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.locatii-servicii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.LOCATII_SERVICII_ACTIVE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.mod-loc-servicii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.MODULE_LOCATII_SERVICII_ACTIVE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.programari-blocare.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_BLOCARE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.programari-ultima-ora.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_ULTIMA_ORA)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.tip-program.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.TIPURI_PROGRAM)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.tip-problema.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.tip-problema-servicii.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA_SERVICII_ACTIVE)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.operatori.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.OPERATORI)
        }
        if (!this.permissionsService.hasPermission('auth-module.ghiseu-settings.ghiseu-zile-libere.list')) {
            this.filteredComponents = this.filteredComponents.filter(item => item !== GhiseulUnicSettingsSidebar.ZILE_LIBERE)
        }
    }

    componentMapping: Record<GhiseulUnicSettingsSidebar, string> = {
        [GhiseulUnicSettingsSidebar.STATUS]: 'app-status',
        [GhiseulUnicSettingsSidebar.PRIORITY]: 'app-priorities',
        [GhiseulUnicSettingsSidebar.TIPURI_PROGRAM_ACTIVE]: 'app-tip-program-active',
        [GhiseulUnicSettingsSidebar.MODULE]: 'app-ghiseu-module',
        [GhiseulUnicSettingsSidebar.LOCATII]: 'app-locatii',
        [GhiseulUnicSettingsSidebar.SERVICII]: 'app-servicii',
        [GhiseulUnicSettingsSidebar.MODULE_LOCATII_ACTIVE]: 'app-module-locatii',
        [GhiseulUnicSettingsSidebar.LOCATII_SERVICII_ACTIVE]: 'app-locatii-servicii',
        [GhiseulUnicSettingsSidebar.MODULE_LOCATII_SERVICII_ACTIVE]: 'app-mod-loc-servicii',
        [GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_BLOCARE]: 'app-programari-blocare',
        [GhiseulUnicSettingsSidebar.PROGRAMARI_SLOTURI_ULTIMA_ORA]: 'app-programari-ultima-ora',
        [GhiseulUnicSettingsSidebar.TIPURI_PROGRAM]: 'app-tip-program',
        [GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA]: 'app-tip-problema',
        [GhiseulUnicSettingsSidebar.TIPURI_PROBLEMA_SERVICII_ACTIVE]: 'app-tip-problema-servicii',
        [GhiseulUnicSettingsSidebar.OPERATORI]: 'app-operatori',
        [GhiseulUnicSettingsSidebar.ZILE_LIBERE]: 'app-zile-libere',
    };

    componentKeys: string[] = Object.keys(this.componentMapping);

    onChange($event: { value: any }) {
        this.selectedComponent = $event.value;
    }

    selectedSection: any = null;
}
